import { SequentialEditSession } from "@decisions/server/DecisionsFramework/Design/Flow/Service/Edit/Mapping/SequentialEditSession";

export function showSequentialPicker(session: SequentialEditSession) {
  if (!DEV_SERVER) {
    $DP.Designers.SequentialPicker.showSequentialPicker(session);
  }
}
